import _get from 'lodash/get';

const globalState = state => state.global;
export const selectAppVersion = state => _get(globalState(state), 'appVersion');
